import { render, staticRenderFns } from "./monitors.vue?vue&type=template&id=b765ddb8&"
import script from "./monitors.vue?vue&type=script&lang=js&"
export * from "./monitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports